
export default class SidebarFilter {
  ready() {
    this.LIBRARY = document.querySelector('.mtt-instructions-library');
    this.LIBRARY_OPEN_CLASS = 'mtt-instructions-library--open';

    this.TOGGLES = document.querySelectorAll('.mtt-filter-sidebar__toggle');
    this.TOGGLE_OPEN_CLASS = 'mtt-filter-sidebar__section--open';

    if (this.TOGGLES.length) {
      this.addListeners();
    }
  }

  toggleSidebarSection(toggleElement) {
    const ITEMS_WRAP = toggleElement.querySelector('.mtt-filter-sidebar__items-wrap');
    const ITEMS = toggleElement.querySelector('.mtt-filter-sidebar__items');
    const ITEMS_HEIGHT = ITEMS.offsetHeight + 24;

    if (toggleElement.classList.contains(this.TOGGLE_OPEN_CLASS)) {
      toggleElement.classList.remove(this.TOGGLE_OPEN_CLASS);
      ITEMS_WRAP.style.maxHeight = 0;
    } else {
      toggleElement.classList.add(this.TOGGLE_OPEN_CLASS);
      ITEMS_WRAP.style.maxHeight = `${ITEMS_HEIGHT}px`;
    }
  }

  toggleSidebar() {
    if (this.LIBRARY.classList.contains(this.LIBRARY_OPEN_CLASS)) {
      this.LIBRARY.classList.remove('mtt-instructions-library--open');
    } else {
      this.LIBRARY.classList.add('mtt-instructions-library--open');
    }
  }

  addListeners() {
    for (let i = 0; i < this.TOGGLES.length; i++) {
      const TOGGLE = this.TOGGLES[i];
      TOGGLE.addEventListener('click', event => this.toggleSidebarSection(event.target.parentNode));
    }

    document.querySelector('#filter-sidebar-toggle').addEventListener('click', () => this.toggleSidebar())
  }
}